class SiteActionUrl
    extends SiteAction {

    private readonly _action: IActionTypeUrl;
    private readonly _card: ISiteCard;

    constructor(card: ISiteCard, action: IActionTypeUrl, next: SiteAction | null) {
        super(next);
        this._action = action;
        this._card = card;
    }
    async _execute() {
        if (this._action.newWindow) {
            window.open(this._action.url, "_blank");
        }
        else {
            window.location.href = this._action.url;
        }
        return true;
    }
}